import React from 'react';

import { Box, Stack } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import OmniSearch from 'src/views-new/OmniSearch';
import OmniSearchProvider from 'src/views-new/OmniSearch/OmniSearchProvider';

import Banners from '../DashboardLayout/components/banners';

import { SettingsNav } from './SettingsNav';

// For now using the old mui components as DashboardLayout because with new ones the layout was not functioning properly
const OrgSettingsLayout: React.FC<{ children?: React.ReactNode }> = ({ children }): JSX.Element => {
  return (
    <OmniSearchProvider>
      <Stack
        sx={{
          height: '100%',
          width: '100%',
          overflow: 'hidden',
          backgroundColor: (theme) => theme.palette.background.default,
        }}
        flexWrap="nowrap"
        direction="row"
      >
        <Box sx={{ flexShrink: 0, flexWrap: 'nowrap', height: '100%', overflowX: 'hidden' }}>
          <SettingsNav />
        </Box>
        <Grid
          container
          wrap="nowrap"
          m={0}
          direction="column"
          sx={{
            boxShadow: (theme) => theme.shadows[3],
            flexGrow: 1,
            overflowX: 'hidden',
            overflowY: 'auto',
            backgroundColor: (theme) => theme.palette.background.paper,
            width: '100%',
            height: '100%',
          }}
        >
          <Banners />
          <Stack style={{ height: '100%' }} direction="row">
            <Box width="100%" p={2.5} display="flex" justifyContent="center">
              {children}
            </Box>
          </Stack>
        </Grid>
      </Stack>
      <OmniSearch />
    </OmniSearchProvider>
  );
};

export default OrgSettingsLayout;
